<div class="flex flex-col lg:flex-row w-full">
  <form class="w-full" [formGroup]="baseForm" (ngSubmit)="onBaseFormSubmit()">
    <div class="flex flex-col w-full">
      <div class="flex flex-col">
        <label class="soft-label top required">Artikelnummer</label>
        <soft-field-ok fieldOkName="artstamm"
          #artstamm
          formControlName="artstamm"
          placeholder="Artikelnummer"
          softFocus>
        </soft-field-ok>
      </div>
      <div class="flex flex-col mt-2">
        <label class="soft-label top required">Einheit</label>
        <soft-field-ok fieldOkName="arteh"
          #arteh
          formControlName="arteh"
          placeholder="Einheit">
        </soft-field-ok>
      </div>
      <div class="flex flex-col mt-2">
        <label class="soft-label top">Kundennummer</label>
        <soft-field-ok fieldOkName="ktostamm.kunde"
          #kunde
          formControlName="kunde"
          placeholder="Kundennummer"
          >
        </soft-field-ok>
      </div>
      <div class="w-full flex flex-row justify-end mt-2">
        <button [disabled]="(loading$ | async) || baseForm.invalid"
          #abfrage
          class="soft-button primary"
          type="submit">
          @if (loading$ | async) {
            <i class="fa-regular fa-spinner fa-spin mr-2"></i>
          }
          Abfragen
        </button>
      </div>
    </div>
  </form>

  <div class="flex flex-col-reverse lg:flex-row w-full">
    <!--Edelmetallkurs-->
    <div class="flex flex-col w-full lg:ml-4 mt-4">
      @if (data$ | async; as data) {
        <h3 class="font-semibold text-lg">Edelmetallkurs</h3>
        <hr />
        <div class="flex w-full mt-2 overflow-x-auto">
          <table class="soft-table-2 compact mt-2">
            <thead>
              <tr>
                <th class="!text-left">Edelmetall</th>
                <th class="text-right">Kurs</th>
                <th class="text-right">VV</th>
                <th class="whitespace-nowrap">
                  <div class="flex flex-row justify-end">
                    Aktionen
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (edelmetall of data.edelmetalle; track edelmetall) {
                <tr>
                  <td data-label="Edelmetall">{{edelmetall.begriff}}</td>
                  <td data-label="Kurs" class="!text-right">{{edelmetall.betrag | number:'1.4-4'}}</td>
                  <td data-label="VV" class="!text-right">{{edelmetall.verarbeitungsverlust | number:'1.4-4'}}%</td>
                  <td data-label="Aktionen">
                    <div class="flex flex-row justify-end">
                      <div class="cursor-pointer" (click)="editEdelmetall(edelmetall)">
                        <i class="fa-regular fa-pen-to-square"></i>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
    <!--Bild-->
    @if(data$ | async){
      <div class="color-light lg:ml-4 mt-4 lg:mt-0 w-full lg:h-44 lg:w-44">
        @if(image$ | async; as image){
          <ng-container>
            <div class="info-box-image dead-center w-full lg:h-44 lg:w-44">
              <img class="h-44" [attr.src]="image | secureImage | async" alt="product image">
            </div>
          </ng-container>
        } @else {
          <ng-container>
            <div class="info-box-image dead-center w-full h-44 lg:w-44">
              <div class="h-44"></div>
            </div>
          </ng-container>
        }
      </div>
    }
  </div>

</div>

@if (data$ | async; as data) {
  <div class="flex flex-col lg:flex-row">
    <div class="flex flex-col w-full md:flex-row">
      <!--Verkaufspreis-->
      <div class="flex flex-col w-full soft-card mt-4">
        <div class="soft-overline">
          Verkaufspreis
        </div>
        <hr />
        <div class="flex flex-row justify-between mt-2">
          <label class="soft-label top">Kundenverkaufspreis</label>
          <div class="h-8">{{($safeNavigationMigration((data$ | async)?.kundenverkaufspreis) | currencyFormat) ?? '-'}}</div>
        </div>
        <div class="flex flex-row justify-between mt-2">
          <label class="soft-label top">Detailsverkaufpreis</label>
          <div class="h-8">{{($safeNavigationMigration((data$ | async)?.detailverkaufspreis) | currencyFormat) ?? '-'}}</div>
        </div>
      </div>
      <!--Herstellkosten-->
      <div class="flex flex-col w-full soft-card mt-4 md:ml-4">
        <div class="soft-overline">
          Herstellungskosten
        </div>
        <hr />
        <div class="flex flex-row justify-between mt-2">
          <label class="soft-label top">Materialwert</label>
          <div class="h-8">{{($safeNavigationMigration((data$ | async)?.materialwert) | currencyFormat) ?? '-'}}</div>
        </div>
        <div class="flex flex-row justify-between mt-2">
          <label class="soft-label top">Arbeitswert</label>
          <div class="h-8">{{($safeNavigationMigration((data$ | async)?.arbeitswert) | currencyFormat) ?? '-'}}</div>
        </div>
        <div class="flex flex-row justify-between mt-2">
          <label class="soft-label top">Legierung</label>
          <div class="h-8">{{($safeNavigationMigration((data$ | async)?.legierung) | currencyFormat) ?? '-'}}</div>
        </div>
        <div class="flex flex-row justify-between mt-2">
          <label class="soft-label top">Gesamte Herstellungskosten</label>
          <div class="h-8">{{($safeNavigationMigration((data$ | async)?.gesamt_herstellkosten) | currencyFormat) ?? '-'}}</div>
        </div>
      </div>
    </div>
    <!--Legierung-->
    <div class="flex flex-col w-full mt-4 lg:ml-4">
      <h3 class="font-semibold text-lg">Legierung</h3>
      <hr />
      <div class="flex w-full mt-2 overflow-x-auto">
        <table class="soft-table-2 compact mt-2">
          <thead>
            <tr>
              <th class="!text-left">Legierung</th>
              <th class="text-right">Gewicht</th>
              <th class="text-right">Preis</th>
              <th class="text-right">Wert</th>
            </tr>
          </thead>
          <tbody>
            @for (legierung of data.legierungen; track legierung) {
              <tr>
                <td data-label="Legierung">{{legierung.legierung}}</td>
                <td data-label="Gewicht" class="!text-right">{{legierung.gewicht | number:'1.4-4'}}</td>
                <td data-label="Preis" class="!text-right">{{legierung.preis | number:'1.4-4'}}</td>
                <td data-label="Wert" class="!text-right">{{legierung.wert | number:'1.4-4'}}</td>
              </tr>
            }
          </tbody>
          <tfoot>
            @if (legierungSum$ | async; as sum) {
              <tr class="font-semibold">
                <td><b>SUMME</b></td>
                <td data-label="Gewicht" class="!text-right">{{ sum.gewicht | number:'1.4-4'}}</td>
                <td class="!text-right"></td>
                <td data-label="Wert" class="!text-right">{{ sum.wert | number:'1.4-4'}}</td>
              </tr>
            }
          </tfoot>
        </table>
      </div>
    </div>
  </div>
  <h3 class="flex flex-row font-semibold text-lg mt-4">
    Materialien
  </h3>
  <hr />
  <div class="flex w-full mt-2 overflow-x-auto">
    <table class="soft-table-2 compact w-full">
      <thead>
        <tr>
          <th class="whitespace-nowrap">Artikelnummer</th>
          <th class="whitespace-nowrap">Bezeichnung</th>
          <th class="whitespace-nowrap">Bezeichnung 2</th>
          <th class="whitespace-nowrap">Legierung</th>
          <th class="whitespace-nowrap text-right">Menge</th>
          <th class="whitespace-nowrap">Einheit</th>
          <th class="whitespace-nowrap text-right">Menge in ct</th>
          <th class="whitespace-nowrap text-right">Menge in g</th>
          <th class="whitespace-nowrap">CT</th>
          <th class="whitespace-nowrap text-right">Gewicht</th>
          <th class="whitespace-nowrap text-right">Preis</th>
          <th class="whitespace-nowrap text-right">Wert</th>
          <th class="whitespace-nowrap text-right">Aufschlag VK</th>
          <th class="whitespace-nowrap">
            <div class="flex flex-row justify-end">
              Aktionen
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (material of data.materialien; track material) {
          <tr>
            <td data-label="Artikelnummer">{{material.artikel.nummer}}</td>
            <td data-label="Bezeichnung">{{material.artikel.artbez1}}</td>
            <td data-label="Bezeichnung 2">{{material.artikel.artbez2}}</td>
            <td data-label="Legierung">{{material?.legierung?.legierung}}</td>
            <td data-label="Menge" class="!text-right">{{material.menge | number:'1.4-4'}}</td>
            <td data-label="Einheit">{{material.arteh?.arteh}}</td>
            <td data-label="Menge in ct" class="!text-right">{{material.mengeCt | number:'1.4-4'}}</td>
            <td data-label="Menge in g" class="!text-right">{{material.mengeCt | number:'1.4-4'}}</td> <!-- TODO: Richtige Property anzeigen -->
            <td data-label="CT">{{material.ct}}</td>
            <td data-label="Gewicht" class="!text-right">{{material.gewicht | number:'1.4-4'}}</td>
            <td data-label="Preis" class="!text-right">{{material.preis | number:'1.4-4'}}</td>
            <td data-label="Wert" class="!text-right">{{material.wert | number:'1.4-4'}}</td>
            <td data-label="Aufschlag VK" class="!text-right">{{$safeNavigationMigration(material?.aufschlagArtikelgruppeDetailverkauf?.aufschlag) | number:'1.4-4'}}%</td>
            <td data-label="Aktionen">
              <div class="flex flex-row justify-end">
                <div class="cursor-pointer" (click)="editMaterial(material)">
                  <i class="fa-regular fa-pen-to-square"></i>
                </div>
                <div class="text-danger cursor-pointer ml-4" (click)="deleteMaterial(material)">
                  <i class="fa-regular fa-trash"></i>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
      <tfoot>
        @if (materialienSum$ | async; as sum) {
          <tr class="font-semibold">
            <td><b>SUMME</b></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right"></td>
            <td></td>
            <td data-label="Menge in ct" class="!text-right">{{ sum.mengeCt | number:'1.4-4'}}</td>
            <td data-label="Menge in g" class="text-right">{{ sum.mengeCt | number:'1.4-4'}}</td> <!-- TODO: Richtige Property anzeigen -->
            <td></td>
            <td data-label="Gewicht" class="!text-right">{{ sum.gewicht | number:'1.4-4'}}</td>
            <td class="text-right"></td>
            <td data-label="Wert" class="!text-right">{{ sum.wert | number:'1.4-4'}}</td>
            <td class="text-right"></td>
            <td></td>
          </tr>
        }
      </tfoot>
    </table>
  </div>
  <div class="flex flex-row w-full justify-end mt-2">
    <div class="ml-2 cursor-pointer text-link" (click)="addMaterial()">
      <i class="fa-regular fa-plus"></i>
      Hinzufügen
    </div>
  </div>
  <h3 class="flex flex-row font-semibold text-lg mt-4">
    Arbeit
  </h3>
  <hr />
  <div class="flex w-full mt-2 overflow-x-auto">
    <table class="soft-table-2 compact w-full">
      <thead>
        <tr>
          <th class="whitespace-nowrap">Artikelnummer</th>
          <th class="whitespace-nowrap">Bezeichnung</th>
          <th class="whitespace-nowrap">Bezeichnung 2</th>
          <th class="whitespace-nowrap !text-right">Menge</th>
          <th class="whitespace-nowrap !text-right">Einheit</th>
          <th class="whitespace-nowrap !text-right">Preis</th>
          <th class="whitespace-nowrap !text-right">Wert</th>
          <th class="whitespace-nowrap !text-right">Aufschlag VK</th>
          <th class="whitespace-nowrap">
            <div class="flex flex-row justify-end">
              Aktionen
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (arbeit of data.arbeit; track arbeit) {
          <tr>
            <td data-label="Artikelnummer">{{arbeit.artikel.nummer}}</td>
            <td data-label="Bezeichnung">{{arbeit.artikel.artbez1}}</td>
            <td data-label="Bezeichnung 2">{{arbeit.artikel.artbez2}}</td>
            <td data-label="Menge" class="!text-right">{{arbeit.menge | number:'1.4-4'}}</td>
            <td data-label="Einheit">{{arbeit?.arteh}}</td>
            <td data-label="Preis" class="!text-right">{{arbeit.preis | number:'1.4-4'}}</td>
            <td data-label="Wert" class="!text-right">{{arbeit.wert | number:'1.4-4'}}</td>
            <td data-label="Aufschlag VK" class="!text-right">{{$safeNavigationMigration(arbeit?.aufschlagArtikelgruppeDetailverkauf?.aufschlag) | number:'1.4-4'}}%</td>
            <td data-label="Aktionen">
              <div class="flex flex-row justify-end">
                <div class="cursor-pointer" (click)="editArbeit(arbeit)">
                  <i class="fa-regular fa-pen-to-square"></i>
                </div>
                <div class="text-danger cursor-pointer ml-4" (click)="deleteArbeit(arbeit)">
                  <i class="fa-regular fa-trash"></i>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
      <tfoot>
        @if (arbeitSum$ | async; as sum) {
          <tr class="font-semibold">
            <td><b>SUMME</b></td>
            <td></td>
            <td></td>
            <td class="text-right"></td>
            <td></td>
            <td class="text-right"></td>
            <td data-label="Wert" class="!text-right">{{ sum.wert | number:'1.4-4'}}</td>
            <td class="text-right"></td>
            <td></td>
          </tr>
        }
      </tfoot>
    </table>
  </div>
  <div class="flex flex-row w-full justify-end mt-2">
    <div class="ml-2 cursor-pointer text-link mb-8" (click)="addArbeit()">
      <i class="fa-regular fa-plus"></i>
      Hinzufügen
    </div>
  </div>
}
